import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueTheMask from "vue-the-mask";
import ConfirmPlugin from "./plugins/confirm";
import { initTheme } from "./services/themeService";
import { useSnackbar } from "./composables/useSnackbar";
import "line-awesome/dist/line-awesome/css/line-awesome.min.css";
import "./assets/styles/tokens.css";
import "./assets/styles/main.css";
import "./assets/styles/salvia-surfaces.css";
import "./assets/styles/salvia-dialogs.css";
import "./assets/styles/salvia-polimento.css";
import "./assets/styles/salvia-dark.css";

Vue.config.productionTip = false;

// REGISTRAR O PLUGIN CORRETAMENTE
Vue.use(VueTheMask);
Vue.use(ConfirmPlugin);

// Aplica o tema salvo ANTES de montar, para não haver flash do tema errado.
// Não depende de login: o valor vem do localStorage.
initTheme(vuetify.framework);

/**
 * Rede de segurança global para erros — salvia-800.
 *
 * NÃO substitui o tratamento das telas: elas dão mensagens específicas
 * ("Erro ao carregar clínica"), muito melhores que um aviso genérico, e um
 * toast global duplicaria cada uma delas.
 *
 * Isto pega só o que ESCAPOU — promessa rejeitada sem catch, erro dentro de
 * um componente. Hoje esses casos falham em silêncio: o usuário clica, nada
 * acontece, e não sobra pista. Como um erro tratado nunca dispara estes
 * eventos, não há risco de aviso em dobro.
 */
const { erroDeRequisicao, error: avisoDeErro } = useSnackbar();

function avisarFalhaNaoTratada(err) {
  // eslint-disable-next-line no-console
  console.error("[salvia] erro não tratado:", err);

  if (err && err.requestId) {
    erroDeRequisicao(err, "Ocorreu um erro inesperado.");
  } else {
    avisoDeErro("Ocorreu um erro inesperado. Tente novamente.");
  }
}

Vue.config.errorHandler = (err) => avisarFalhaNaoTratada(err);
window.addEventListener("unhandledrejection", (e) =>
  avisarFalhaNaoTratada(e.reason),
);

new Vue({
  router,
  store,
  vuetify,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
